import React from 'react';
import { Tooltip } from 'npo/pages/ReportBuilder/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import { InvestmentColumnKeys } from '../utils';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface ShowErrorIconProps {
  systemKey: InvestmentColumnKeys | undefined;
  className?: string;
}

const ShowErrorIcon: React.FC<ShowErrorIconProps> = ({
  systemKey,
  className,
}) => {
  const icon = (
    <FontAwesomeIcon
      icon={faCircleExclamation}
      color={COLORS.critical}
      className={className}
    />
  );
  let tooltipComponent: JSX.Element | undefined = undefined;
  switch (systemKey) {
    case 'allocateDueDate':
    case 'submitDueDate':
    case 'interimDueDate':
    case 'publishDueDate':
    case 'resolveDueDate':
    case 'finalizeDueDate':
      tooltipComponent = <>Format should be YYYY-MM-DD</>;
      break;
    case 'portfolioName':
      tooltipComponent = (
        <>Please make sure that portfolio exists in the system.</>
      );
      break;
    case 'relationshipManagerEmail':
      tooltipComponent = (
        <>Please make sure that donor's email exists in the system.</>
      );
      break;
    case 'contactEmail':
      tooltipComponent = <>Please enter a valid email address.</>;
      break;

    default:
      break;
  }
  return tooltipComponent ? (
    <Tooltip arrow={true} title={tooltipComponent}>
      {icon}
    </Tooltip>
  ) : (
    icon
  );
};

export default ShowErrorIcon;
